var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "requirementsForm",
          staticClass: "form-container",
          attrs: { model: _vm.form, size: "small", "label-width": "120px" },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "房屋单价", prop: "housePrice" } },
                    _vm._l(_vm.dict.house_price, function (item) {
                      return _c(
                        "el-radio",
                        {
                          key: item.id,
                          staticClass: "no-gray-disabled",
                          attrs: {
                            label: item.value,
                            disabled: !_vm.$parent.checkPer([
                              "admin",
                              "customers:requirementsEdit",
                            ]),
                          },
                          model: {
                            value: _vm.form.housePrice,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "housePrice", $$v)
                            },
                            expression: "form.housePrice",
                          },
                        },
                        [_vm._v(_vm._s(item.label))]
                      )
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "房屋面积", prop: "houseArea" } },
                    _vm._l(_vm.dict.house_area, function (item) {
                      return _c(
                        "el-radio",
                        {
                          key: item.id,
                          staticClass: "no-gray-disabled",
                          attrs: {
                            label: item.value,
                            disabled: !_vm.$parent.checkPer([
                              "admin",
                              "customers:requirementsEdit",
                            ]),
                          },
                          model: {
                            value: _vm.form.houseArea,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "houseArea", $$v)
                            },
                            expression: "form.houseArea",
                          },
                        },
                        [_vm._v(_vm._s(item.label))]
                      )
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "喜欢风格", prop: "likeStyle" } },
                    [
                      _c(
                        "el-checkbox-group",
                        {
                          attrs: {
                            disabled: !_vm.$parent.checkPer([
                              "admin",
                              "customers:requirementsEdit",
                            ]),
                          },
                          model: {
                            value: _vm.form.likeStyle,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "likeStyle", $$v)
                            },
                            expression: "form.likeStyle",
                          },
                        },
                        _vm._l(_vm.dict.like_style, function (item) {
                          return _c(
                            "el-checkbox",
                            {
                              key: item.label,
                              staticClass: "no-gray-disabled",
                              attrs: { label: item.label },
                              on: {
                                change: function ($event) {
                                  return _vm.handleChange($event, item.id)
                                },
                              },
                            },
                            [_vm._v(_vm._s(item.label))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "入住时间", prop: "occupancyTimeLimit" },
                    },
                    _vm._l(_vm.dict.occupancy_time_limit, function (item) {
                      return _c(
                        "el-radio",
                        {
                          key: item.id,
                          staticClass: "no-gray-disabled",
                          attrs: {
                            label: item.value,
                            disabled: !_vm.$parent.checkPer([
                              "admin",
                              "customers:requirementsEdit",
                            ]),
                          },
                          model: {
                            value: _vm.form.occupancyTimeLimit,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "occupancyTimeLimit", $$v)
                            },
                            expression: "form.occupancyTimeLimit",
                          },
                        },
                        [_vm._v(_vm._s(item.label))]
                      )
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "产品需求", prop: "productDemand" } },
                    [
                      _c(
                        "el-checkbox-group",
                        {
                          attrs: {
                            disabled: !_vm.$parent.checkPer([
                              "admin",
                              "customers:requirementsEdit",
                            ]),
                          },
                          model: {
                            value: _vm.form.productDemand,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "productDemand", $$v)
                            },
                            expression: "form.productDemand",
                          },
                        },
                        _vm._l(_vm.dict.cust_need_product, function (item) {
                          return _c(
                            "el-checkbox",
                            {
                              key: item.label,
                              staticClass: "no-gray-disabled",
                              attrs: { label: item.label },
                              on: {
                                change: function ($event) {
                                  return _vm.handleChange($event, item.id)
                                },
                              },
                            },
                            [_vm._v(_vm._s(item.label))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "客户注重", prop: "kfFocusesFeel" } },
                    [
                      _c(
                        "el-checkbox-group",
                        {
                          attrs: {
                            disabled: !_vm.$parent.checkPer([
                              "admin",
                              "customers:requirementsEdit",
                            ]),
                          },
                          model: {
                            value: _vm.form.kfFocusesFeel,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "kfFocusesFeel", $$v)
                            },
                            expression: "form.kfFocusesFeel",
                          },
                        },
                        _vm._l(_vm.dict.kf_focuses_feel, function (item) {
                          return _c(
                            "el-checkbox",
                            {
                              key: item.label,
                              staticClass: "no-gray-disabled",
                              attrs: { label: item.label },
                              on: {
                                change: function ($event) {
                                  return _vm.handleChange($event, item.id)
                                },
                              },
                            },
                            [_vm._v(_vm._s(item.label))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "客户等级", prop: "custLevel" } },
                    _vm._l(_vm.dict.cust_level, function (item) {
                      return _c(
                        "el-radio",
                        {
                          key: item.id,
                          staticClass: "no-gray-disabled",
                          attrs: {
                            label: item.value,
                            disabled: !_vm.$parent.checkPer([
                              "admin",
                              "customers:requirementsEdit",
                            ]),
                          },
                          model: {
                            value: _vm.form.custLevel,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "custLevel", $$v)
                            },
                            expression: "form.custLevel",
                          },
                        },
                        [_vm._v(_vm._s(item.label))]
                      )
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "装修状态", prop: "decorateState" } },
                    _vm._l(_vm.dict.decorate_state, function (item) {
                      return _c(
                        "el-radio",
                        {
                          key: item.id,
                          staticClass: "no-gray-disabled",
                          attrs: {
                            label: item.value,
                            disabled: !_vm.$parent.checkPer([
                              "admin",
                              "customers:requirementsEdit",
                            ]),
                          },
                          model: {
                            value: _vm.form.decorateState,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "decorateState", $$v)
                            },
                            expression: "form.decorateState",
                          },
                        },
                        [_vm._v(_vm._s(item.label))]
                      )
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "交房时间", prop: "giveRoomTime" } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "datetime",
                          disabled: !_vm.$parent.checkPer([
                            "admin",
                            "customers:requirementsEdit",
                          ]),
                        },
                        model: {
                          value: _vm.form.giveRoomTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "giveRoomTime", $$v)
                          },
                          expression: "form.giveRoomTime",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "装修类型", prop: "decorateType" } },
                    _vm._l(_vm.dict.decorate_type, function (item) {
                      return _c(
                        "el-radio",
                        {
                          key: item.id,
                          staticClass: "no-gray-disabled",
                          attrs: {
                            label: item.value,
                            disabled: !_vm.$parent.checkPer([
                              "admin",
                              "customers:requirementsEdit",
                            ]),
                          },
                          model: {
                            value: _vm.form.decorateType,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "decorateType", $$v)
                            },
                            expression: "form.decorateType",
                          },
                        },
                        [_vm._v(_vm._s(item.label))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "text-align": "right", "margin-top": "20px" } },
        [
          _vm.$parent.checkPer(["admin", "customers:requirementsEdit"])
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.saveRequirements },
                },
                [_vm._v("\n      保存\n    ")]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }